import { useAppearance } from '@backoffice-frontend/dark-mode'

export const PictureConstructionSite = () => {
  const { darkMode } = useAppearance()
  return darkMode ? (
    <PictureConstructionSiteDark />
  ) : (
    <PictureConstructionSiteLight />
  )
}

const PictureConstructionSiteDark = () => {
  return (
    <svg
      width="380"
      height="158"
      viewBox="0 0 380 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M269.609 135.585L304.494 139.654C305.327 139.75 306.168 139.649 306.959 139.357L328.487 132.204C328.487 130.824 327.442 129.665 326.065 129.522L298.469 126.674C297.561 126.611 296.651 126.672 295.759 126.852L272.207 132.321C270.686 132.674 269.613 134.027 269.613 135.583L269.609 135.585Z"
        fill="#29333A"
      />
      <path
        d="M295.553 79.9471L279.313 130.854C279.313 130.854 297.124 138.661 320.644 130.226L303.57 79.7614C303.301 78.9682 302.634 78.3688 301.811 78.2053C300.806 78.0055 299.308 77.8683 297.516 78.2053C296.59 78.3789 295.838 79.051 295.551 79.9471H295.553Z"
        fill="#475056"
      />
      <path
        d="M305.307 84.894L303.57 79.7636C303.301 78.9704 302.634 78.371 301.811 78.2075C300.806 78.0077 299.308 77.8705 297.516 78.2075C296.59 78.3811 295.838 79.0531 295.551 79.9493L293.978 84.8799C297.666 85.8588 301.611 85.8527 305.304 84.894H305.307Z"
        fill="#29333A"
      />
      <path
        d="M290.905 94.519L287.532 105.089C294.154 106.766 301.111 107.123 307.868 106.114C309.31 105.898 310.782 105.601 312.13 105.064L308.633 94.7249C307.415 95.0236 306.158 95.1992 304.908 95.3183C300.236 95.7643 295.497 95.4918 290.905 94.519Z"
        fill="#29333A"
      />
      <path
        d="M318.368 123.496L314.876 113.176C310.299 115.106 305.286 116.006 300.307 116.014C295.066 116.022 289.858 115.071 284.847 113.509L281.588 123.726C293.556 127.03 306.443 126.947 318.368 123.496Z"
        fill="#29333A"
      />
      <path
        d="M51.3 109.888L77.5236 112.869C78.1484 112.94 78.7812 112.865 79.3756 112.651L95.5586 107.414C95.5586 106.403 94.7721 105.555 93.7369 105.45L72.9926 103.365C72.3112 103.319 71.6258 103.365 70.9566 103.496L53.2511 107.501C52.1088 107.759 51.3 108.748 51.3 109.89V109.888Z"
        fill="#29333A"
      />
      <path
        d="M70.803 69.1473L58.595 106.425C58.595 106.425 71.9837 112.143 89.6649 105.967L76.8301 69.0121C76.628 68.4308 76.1265 67.9929 75.5078 67.8738C74.7537 67.7285 73.6255 67.6276 72.2789 67.8738C71.5834 68.001 71.0173 68.4934 70.803 69.1494V69.1473Z"
        fill="#475056"
      />
      <path
        d="M78.1342 72.7681L76.8301 69.0121C76.6279 68.4308 76.1265 67.9929 75.5078 67.8738C74.7536 67.7285 73.6254 67.6276 72.2789 67.8738C71.5833 68.001 71.0172 68.4934 70.8029 69.1494L69.6201 72.76C72.3921 73.4765 75.3582 73.4725 78.1342 72.7701V72.7681Z"
        fill="#29333A"
      />
      <path
        d="M67.3091 79.8157L64.7737 87.5557C69.7515 88.7849 74.98 89.0452 80.061 88.3065C81.1447 88.1491 82.2507 87.9311 83.2636 87.5376L80.6332 79.965C79.7173 80.185 78.7731 80.3122 77.8349 80.3989C74.3229 80.7259 70.7604 80.5261 67.3091 79.8136V79.8157Z"
        fill="#29333A"
      />
      <path
        d="M87.9524 101.036L85.328 93.4796C81.8868 94.8924 78.118 95.5524 74.3756 95.5584C70.435 95.5645 66.5206 94.8682 62.7559 93.7238L60.3054 101.206C69.3007 103.625 78.9874 103.565 87.9524 101.036Z"
        fill="#29333A"
      />
      <path
        d="M106.149 110.744L128.75 113.315L140.737 109.553L121.604 107.516L106.149 110.744Z"
        fill="#475056"
      />
      <path
        d="M128.75 113.315L132.973 119.469L100.243 115.594L106.149 110.744L128.75 113.315Z"
        fill="#475056"
      />
      <path
        d="M128.75 113.315L132.973 119.469L146.142 114.643L140.737 109.553L128.75 113.315Z"
        fill="#29333A"
      />
      <path
        d="M218.438 123.882L244.394 126.748L259.429 121.267L236.834 118.962L218.438 123.882Z"
        fill="#475056"
      />
      <path
        d="M244.394 126.748L247.896 133.177L212.416 129.158L218.437 123.882L244.394 126.748Z"
        fill="#475056"
      />
      <path
        d="M244.394 126.749L247.896 133.177L263.958 126.244L259.429 121.267L244.394 126.749Z"
        fill="#29333A"
      />
      <path
        d="M229.123 97.5098L229.398 70.2772L225.496 70.2006L225.231 97.2192L213.526 96.3392L213.759 69.361L209.871 69.2863L209.648 96.0486L198.734 95.2271L198.931 68.4608L195.055 68.3861L194.869 94.9385L184.003 94.1211L184.165 66.9915L180.299 66.9168L180.15 93.8325L168.944 92.9909L169.066 66.7029L165.214 66.6302L165.103 92.7023L154.074 91.8728L154.156 66.1176L150.317 66.0449L150.244 91.5862L139.872 90.8071L139.918 65.8451L136.093 65.7725L136.055 90.5205L127.979 89.913L127.998 66.9007L123.901 66.0247L123.889 92.9203L236.978 102.858L237.716 98.1557L229.123 97.5098Z"
        fill="#29333A"
      />
      <path
        d="M125.662 28.8056L128.028 29.9903L127.961 110.707L125.614 111.272L125.662 28.8056Z"
        fill="#29333A"
      />
      <path
        d="M241.588 29.1774L243.992 29.8515L244.406 125.772L241.588 126.676V29.1774Z"
        fill="#29333A"
      />
      <path
        d="M230.088 30.5193C230.092 30.376 230.154 30.2428 230.213 30.1116C231.558 27.1205 231.412 23.631 229.208 21.0677C227.627 19.2271 225.288 18.2946 222.904 18.3289C219.903 18.3713 217.417 20.5591 216.962 23.5623C216.616 25.847 217.455 28.2326 218.949 29.9925C218.822 30.2146 218.149 32.9372 218.011 32.917C220.071 33.2339 222.178 33.1027 224.244 33.2036C225.492 33.2642 226.748 33.5588 228.001 33.6497C229.178 33.7344 230.367 33.5871 231.543 33.575C231.05 32.7152 230.599 31.8292 230.197 30.923C230.142 30.8019 230.09 30.6747 230.088 30.5435C230.088 30.5355 230.088 30.5294 230.088 30.5213V30.5193Z"
        fill="#475056"
      />
      <path
        d="M227.182 30.4125C228.365 29.1672 229.105 27.4557 229.125 25.5545C229.163 21.6815 226.203 18.4986 222.513 18.4482C218.828 18.3977 215.813 21.4938 215.779 25.3628C215.764 26.9794 216.274 28.4729 217.137 29.6698C216.763 30.7415 216.418 31.8112 216.025 32.8849C218.482 33.2623 226.618 33.1311 228.154 33.7729C228.108 33.781 228.165 33.8617 228.203 33.8335C228.241 33.8032 228.229 33.7447 228.215 33.6982C227.869 32.6043 227.526 31.5084 227.18 30.4125H227.182Z"
        fill="#475056"
      />
      <path
        d="M226.861 25.4432C226.836 27.9156 224.78 29.8895 222.267 29.8511C219.754 29.8128 217.74 27.7824 217.762 25.312C217.784 22.8417 219.839 20.8658 222.35 20.9001C224.863 20.9344 226.883 22.9688 226.859 25.4432H226.861Z"
        fill="#29333A"
      />
      <path
        d="M182.155 30.1099C182.159 29.9726 182.213 29.8455 182.264 29.7204C183.445 26.8564 183.303 23.5182 181.342 21.068C179.935 19.3081 177.862 18.418 175.752 18.4523C173.095 18.4947 170.901 20.5917 170.509 23.4657C170.21 25.6535 170.962 27.9342 172.29 29.6174C172.179 29.8314 171.591 32.437 171.469 32.4168C173.295 32.7175 175.159 32.5903 176.989 32.6852C178.093 32.7417 179.207 33.0223 180.317 33.107C181.36 33.1878 182.41 33.0445 183.453 33.0323C183.012 32.2109 182.612 31.3632 182.252 30.4954C182.203 30.3783 182.155 30.2592 182.153 30.1321C182.153 30.126 182.153 30.118 182.153 30.1119L182.155 30.1099Z"
        fill="#475056"
      />
      <path
        d="M179.583 30.0112C180.626 28.8184 181.275 27.1796 181.286 25.3611C181.306 21.6555 178.675 18.612 175.408 18.5676C172.141 18.5232 169.486 21.49 169.47 25.1916C169.462 26.7376 169.919 28.1665 170.689 29.3129C170.361 30.3402 170.058 31.3634 169.717 32.3907C171.894 32.748 179.094 32.6148 180.459 33.2263C180.416 33.2344 180.469 33.3111 180.501 33.2828C180.533 33.2546 180.525 33.198 180.511 33.1536C180.202 32.1062 179.893 31.0587 179.583 30.0112Z"
        fill="#475056"
      />
      <path
        d="M179.282 24.8462C179.27 27.2117 177.454 29.1028 175.23 29.0705C173.006 29.0382 171.215 27.0946 171.227 24.7312C171.239 22.3678 173.051 20.4726 175.275 20.5049C177.499 20.5372 179.294 22.4808 179.282 24.8483V24.8462Z"
        fill="#29333A"
      />
      <path
        d="M142.124 29.9563C142.126 29.8271 142.179 29.704 142.225 29.587C143.331 26.8684 143.186 23.6997 141.326 21.3706C139.989 19.6995 138.028 18.8558 136.032 18.8861C133.521 18.9265 131.455 20.9185 131.093 23.6452C130.818 25.722 131.536 27.8876 132.797 29.4861C132.692 29.6879 132.146 32.1623 132.031 32.1441C133.758 32.4287 135.521 32.3076 137.25 32.3984C138.295 32.4529 139.346 32.7173 140.396 32.8001C141.382 32.8768 142.375 32.7395 143.36 32.7294C142.941 31.9484 142.559 31.1451 142.215 30.3216C142.169 30.2106 142.124 30.0976 142.122 29.9765C142.122 29.9704 142.122 29.9644 142.122 29.9563H142.124Z"
        fill="#475056"
      />
      <path
        d="M139.694 29.8635C140.677 28.7312 141.283 27.1751 141.287 25.4475C141.295 21.9276 138.796 19.0395 135.709 18.9971C132.621 18.9547 130.122 21.7702 130.118 25.286C130.118 26.7553 130.553 28.1116 131.285 29.1995C130.98 30.1743 130.697 31.1451 130.375 32.1239C132.433 32.465 139.241 32.3359 140.533 32.9171C140.495 32.9232 140.543 32.9978 140.573 32.9716C140.604 32.9454 140.596 32.8909 140.584 32.8485C140.288 31.8535 139.991 30.8585 139.696 29.8655L139.694 29.8635Z"
        fill="#475056"
      />
      <path
        d="M139.393 24.9407C139.389 27.187 137.68 28.9833 135.577 28.951C133.477 28.9187 131.776 27.076 131.778 24.8297C131.78 22.5834 133.487 20.7871 135.59 20.8154C137.692 20.8436 139.397 22.6924 139.393 24.9387V24.9407Z"
        fill="#29333A"
      />
      <path
        d="M234.851 29.2922L234.822 32.1198L125.66 31.9402V28.8038L119.134 28.7069V110.324L125.612 111.272L125.62 96.8236L234.436 106.651V125.915L241.584 126.674V29.1731L234.849 29.2902L234.851 29.2922ZM133.357 92.452L125.624 91.8042L125.638 67.0561L133.388 67.375L133.355 92.452H133.357ZM147.603 93.6449L137.351 92.7871L137.393 67.5405L147.67 67.9623L147.603 93.6469V93.6449ZM162.292 94.876L151.609 93.9819L151.686 68.1278L162.395 68.5678L162.29 94.878L162.292 94.876ZM176.933 96.1031L166.312 95.213L166.427 68.7313L177.076 69.1672L176.933 96.1011V96.1031ZM191.512 97.3242L181.154 96.4563L181.308 69.3428L191.694 69.7687L191.51 97.3242H191.512ZM206.339 98.5654L195.748 97.6774L195.944 69.9402L206.567 70.3762L206.341 98.5634L206.339 98.5654ZM221.818 99.8611L210.586 98.9206L210.825 70.5518L222.091 71.014L221.818 99.8611ZM233.785 100.864L226.08 100.218L226.365 71.1895L234.095 71.5064L233.785 100.864Z"
        fill="#475056"
      />
      <path
        d="M172.161 36.7356L184.074 36.9233L183.91 64.3012L172.032 63.845L172.161 36.7356Z"
        fill="#29333A"
      />
      <path
        d="M137.448 36.1886L137.403 62.519L125.642 62.0689L125.658 36.0029L137.448 36.1886Z"
        fill="#29333A"
      />
      <path
        d="M148.048 36.3561L159.896 36.5418L159.795 63.3768L147.978 62.9247L148.048 36.3561Z"
        fill="#29333A"
      />
      <path
        d="M208.963 65.2598L197.018 64.8037L197.216 37.1292L209.193 37.3189L208.963 65.2598Z"
        fill="#29333A"
      />
      <path
        d="M234.151 66.2264L222.141 65.7662L222.408 37.5266L234.452 37.7163L234.151 66.2264Z"
        fill="#29333A"
      />
    </svg>
  )
}

const PictureConstructionSiteLight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="380"
      height="160"
      viewBox="0 0 380 160"
      fill="none"
    >
      <path
        d="M269.609 136.834L304.494 140.921C305.327 141.018 306.168 140.917 306.959 140.623L328.487 133.439C328.487 132.052 327.442 130.889 326.065 130.745L298.469 127.884C297.561 127.822 296.651 127.882 295.759 128.063L272.207 133.556C270.686 133.911 269.613 135.269 269.613 136.832L269.609 136.834Z"
        fill="#B3B6B9"
      />
      <path
        d="M295.553 80.9513L279.313 132.083C279.313 132.083 297.124 139.924 320.644 131.452L303.57 80.7648C303.301 79.9681 302.634 79.366 301.811 79.2018C300.806 79.0011 299.308 78.8633 297.516 79.2018C296.59 79.3762 295.838 80.0512 295.551 80.9513H295.553Z"
        fill="#E6E7E8"
      />
      <path
        d="M305.307 85.92L303.57 80.7669C303.301 79.9702 302.634 79.3682 301.811 79.204C300.806 79.0033 299.308 78.8654 297.516 79.204C296.59 79.3783 295.838 80.0534 295.551 80.9534L293.978 85.9058C297.666 86.889 301.611 86.8829 305.304 85.92H305.307Z"
        fill="#B3B6B9"
      />
      <path
        d="M290.905 95.5875L287.532 106.204C294.154 107.888 301.111 108.247 307.868 107.234C309.31 107.017 310.782 106.719 312.13 106.18L308.633 95.7943C307.415 96.0943 306.158 96.2707 304.908 96.3903C300.236 96.8383 295.497 96.5646 290.905 95.5875Z"
        fill="#B3B6B9"
      />
      <path
        d="M318.368 124.692L314.876 114.327C310.299 116.265 305.286 117.169 300.307 117.177C295.066 117.185 289.858 116.23 284.847 114.661L281.588 124.923C293.556 128.242 306.443 128.158 318.368 124.692Z"
        fill="#B3B6B9"
      />
      <path
        d="M51.3 111.024L77.5236 114.019C78.1484 114.09 78.7812 114.015 79.3756 113.8L95.5586 108.539C95.5586 107.524 94.7721 106.672 93.7369 106.567L72.9926 104.473C72.3112 104.426 71.6258 104.473 70.9566 104.604L53.2511 108.626C52.1088 108.886 51.3 109.879 51.3 111.027V111.024Z"
        fill="#B3B6B9"
      />
      <path
        d="M70.803 70.1038L58.595 107.546C58.595 107.546 71.9837 113.289 89.6649 107.086L76.8302 69.968C76.628 69.3842 76.1265 68.9443 75.5079 68.8247C74.7537 68.6787 73.6255 68.5774 72.2789 68.8247C71.5834 68.9524 71.0173 69.447 70.803 70.1059V70.1038Z"
        fill="#E6E7E8"
      />
      <path
        d="M78.1342 73.7406L76.8301 69.968C76.6279 69.3842 76.1265 68.9443 75.5078 68.8247C74.7536 68.6787 73.6254 68.5774 72.2789 68.8247C71.5833 68.9524 71.0172 69.447 70.8029 70.1059L69.6201 73.7325C72.3921 74.4521 75.3582 74.4481 78.1342 73.7426V73.7406Z"
        fill="#B3B6B9"
      />
      <path
        d="M67.3091 80.8193L64.7737 88.5935C69.7515 89.828 74.98 90.0896 80.061 89.3476C81.1447 89.1895 82.2507 88.9706 83.2636 88.5753L80.6332 80.9693C79.7173 81.1902 78.7731 81.3179 77.8349 81.4051C74.3229 81.7335 70.7604 81.5328 67.3091 80.8172V80.8193Z"
        fill="#B3B6B9"
      />
      <path
        d="M87.9524 102.133L85.328 94.5435C81.8868 95.9625 78.118 96.6254 74.3756 96.6315C70.435 96.6376 66.5206 95.9382 62.7559 94.7888L60.3054 102.304C69.3007 104.734 78.9874 104.673 87.9524 102.133Z"
        fill="#B3B6B9"
      />
      <path
        d="M106.149 111.884L128.75 114.466L140.737 110.688L121.604 108.642L106.149 111.884Z"
        fill="#E6E7E8"
      />
      <path
        d="M128.75 114.466L132.973 120.647L100.243 116.755L106.149 111.884L128.75 114.466Z"
        fill="#E6E7E8"
      />
      <path
        d="M128.75 114.467L132.973 120.647L146.142 115.8L140.737 110.688L128.75 114.467Z"
        fill="#B3B6B9"
      />
      <path
        d="M218.438 125.081L244.394 127.959L259.429 122.453L236.834 120.138L218.438 125.081Z"
        fill="#E6E7E8"
      />
      <path
        d="M244.394 127.959L247.896 134.416L212.416 130.38L218.437 125.081L244.394 127.959Z"
        fill="#E6E7E8"
      />
      <path
        d="M244.394 127.959L247.896 134.416L263.958 127.453L259.429 122.454L244.394 127.959Z"
        fill="#B3B6B9"
      />
      <path
        d="M229.123 98.5915L229.398 71.2387L225.496 71.1617L225.231 98.2996L213.526 97.4157L213.759 70.3184L209.871 70.2434L209.648 97.1238L198.734 96.2987L198.931 69.4143L195.055 69.3393L194.869 96.0088L184.003 95.1878L184.165 67.9385L180.299 67.8635L180.15 94.8979L168.944 94.0526L169.066 67.6486L165.214 67.5756L165.103 93.7627L154.074 92.9296L154.156 67.0607L150.317 66.9877L150.244 92.6417L139.872 91.8592L139.918 66.787L136.093 66.7141L136.055 91.5713L127.979 90.9612L127.998 67.8472L123.901 66.9674L123.889 93.9817L236.978 103.963L237.716 99.2402L229.123 98.5915Z"
        fill="#B3B6B9"
      />
      <path
        d="M125.662 29.584L128.028 30.774L127.961 111.847L125.614 112.415L125.662 29.584Z"
        fill="#B3B6B9"
      />
      <path
        d="M241.588 29.9574L243.992 30.6345L244.406 126.978L241.588 127.886V29.9574Z"
        fill="#B3B6B9"
      />
      <path
        d="M230.088 31.3054C230.092 31.1614 230.154 31.0276 230.213 30.8959C231.558 27.8916 231.412 24.3866 229.208 21.8121C227.627 19.9633 225.288 19.0267 222.904 19.0612C219.903 19.1038 217.417 21.3012 216.962 24.3177C216.616 26.6124 217.455 29.0086 218.949 30.7763C218.822 30.9993 218.149 33.7339 218.011 33.7136C220.071 34.0319 222.178 33.9001 224.244 34.0015C225.492 34.0623 226.748 34.3583 228.001 34.4495C229.178 34.5347 230.367 34.3867 231.543 34.3745C231.05 33.5109 230.599 32.621 230.197 31.7108C230.142 31.5892 230.09 31.4614 230.088 31.3297C230.088 31.3216 230.088 31.3155 230.088 31.3074V31.3054Z"
        fill="#E6E7E8"
      />
      <path
        d="M227.182 31.1981C228.365 29.9473 229.105 28.2282 229.125 26.3186C229.163 22.4285 226.203 19.2316 222.513 19.1809C218.828 19.1303 215.813 22.24 215.779 26.1261C215.764 27.7498 216.274 29.2499 217.137 30.4521C216.763 31.5285 216.418 32.6029 216.025 33.6814C218.482 34.0604 226.618 33.9287 228.154 34.5733C228.108 34.5814 228.165 34.6625 228.203 34.6341C228.241 34.6037 228.229 34.5449 228.215 34.4983C227.869 33.3996 227.526 32.2988 227.18 31.1981H227.182Z"
        fill="#E6E7E8"
      />
      <path
        d="M226.861 26.2068C226.836 28.6901 224.78 30.6727 222.267 30.6342C219.754 30.5957 217.74 28.5564 217.762 26.0751C217.784 23.5938 219.839 21.6092 222.35 21.6437C224.863 21.6781 226.883 23.7215 226.859 26.2068H226.861Z"
        fill="#B3B6B9"
      />
      <path
        d="M182.155 30.8941C182.159 30.7562 182.213 30.6285 182.264 30.5028C183.445 27.6263 183.303 24.2733 181.342 21.8123C179.935 20.0446 177.862 19.1506 175.752 19.1851C173.095 19.2276 170.901 21.3339 170.509 24.2206C170.21 26.4181 170.962 28.7088 172.29 30.3994C172.179 30.6143 171.591 33.2314 171.469 33.2111C173.295 33.5132 175.159 33.3855 176.989 33.4808C178.093 33.5375 179.207 33.8193 180.317 33.9044C181.36 33.9855 182.41 33.8416 183.453 33.8294C183.012 33.0044 182.612 32.153 182.252 31.2813C182.203 31.1637 182.155 31.0441 182.153 30.9164C182.153 30.9103 182.153 30.9022 182.153 30.8961L182.155 30.8941Z"
        fill="#E6E7E8"
      />
      <path
        d="M179.583 30.795C180.626 29.5969 181.275 27.9508 181.286 26.1243C181.306 22.4024 178.675 19.3454 175.408 19.3008C172.141 19.2563 169.486 22.2362 169.47 25.9541C169.462 27.5069 169.919 28.9421 170.689 30.0936C170.361 31.1254 170.058 32.1532 169.717 33.185C171.894 33.5438 179.094 33.41 180.459 34.0243C180.416 34.0324 180.469 34.1094 180.501 34.081C180.533 34.0526 180.525 33.9959 180.511 33.9513C180.202 32.8992 179.893 31.8471 179.583 30.795Z"
        fill="#E6E7E8"
      />
      <path
        d="M179.282 25.6072C179.27 27.9831 177.454 29.8825 175.23 29.8501C173.006 29.8177 171.215 27.8655 171.227 25.4917C171.239 23.1178 173.051 21.2143 175.275 21.2467C177.499 21.2792 179.294 23.2314 179.282 25.6092V25.6072Z"
        fill="#B3B6B9"
      />
      <path
        d="M142.124 30.7399C142.126 30.6101 142.179 30.4865 142.225 30.3689C143.331 27.6383 143.186 24.4556 141.326 22.1163C139.989 20.4377 138.028 19.5904 136.032 19.6208C133.521 19.6613 131.455 21.6622 131.093 24.4009C130.818 26.4868 131.536 28.662 132.797 30.2675C132.692 30.4703 132.146 32.9556 132.031 32.9373C133.758 33.2232 135.521 33.1015 137.25 33.1928C138.295 33.2475 139.346 33.5131 140.396 33.5962C141.382 33.6732 142.375 33.5354 143.36 33.5252C142.941 32.7407 142.559 31.9339 142.215 31.1068C142.169 30.9953 142.124 30.8818 142.122 30.7601C142.122 30.7541 142.122 30.748 142.122 30.7399H142.124Z"
        fill="#E6E7E8"
      />
      <path
        d="M139.694 30.6466C140.677 29.5093 141.283 27.9464 141.287 26.2111C141.295 22.6757 138.796 19.7748 135.709 19.7323C132.621 19.6897 130.122 22.5176 130.118 26.049C130.118 27.5247 130.553 28.887 131.285 29.9797C130.98 30.9588 130.697 31.9339 130.375 32.917C132.433 33.2596 139.241 33.1299 140.533 33.7137C140.495 33.7198 140.543 33.7948 140.573 33.7685C140.604 33.7421 140.596 33.6874 140.584 33.6448C140.288 32.6454 139.991 31.646 139.696 30.6486L139.694 30.6466Z"
        fill="#E6E7E8"
      />
      <path
        d="M139.393 25.7021C139.389 27.9584 137.68 29.7626 135.577 29.7301C133.477 29.6977 131.776 27.8469 131.778 25.5906C131.78 23.3344 133.487 21.5302 135.59 21.5586C137.692 21.5869 139.397 23.4438 139.393 25.7001V25.7021Z"
        fill="#B3B6B9"
      />
      <path
        d="M234.851 30.0728L234.822 32.9129L125.66 32.7325V29.5822L119.134 29.4849V111.462L125.612 112.415L125.62 97.9023L234.436 107.773V127.122L241.584 127.884V29.9532L234.849 30.0708L234.851 30.0728ZM133.357 93.5114L125.624 92.8607L125.638 68.0034L133.388 68.3237L133.355 93.5114H133.357ZM147.603 94.7095L137.351 93.8479L137.393 68.4899L147.67 68.9136L147.603 94.7115V94.7095ZM162.292 95.946L151.609 95.048L151.686 69.0798L162.395 69.5217L162.29 95.9481L162.292 95.946ZM176.933 97.1786L166.312 96.2846L166.427 69.6859L177.076 70.1238L176.933 97.1765V97.1786ZM191.512 98.405L181.154 97.5333L181.308 70.3002L191.694 70.7279L191.51 98.405H191.512ZM206.339 99.6517L195.748 98.7598L195.944 70.9002L206.567 71.3381L206.341 99.6497L206.339 99.6517ZM221.818 100.953L210.586 100.008L210.825 71.5145L222.091 71.9787L221.818 100.953ZM233.785 101.961L226.08 101.312L226.365 72.155L234.095 72.4733L233.785 101.961Z"
        fill="#E6E7E8"
      />
      <path
        d="M172.161 37.549L184.074 37.7376L183.91 65.2363L172.032 64.7781L172.161 37.549Z"
        fill="#B3B6B9"
      />
      <path
        d="M137.448 36.9996L137.403 63.4462L125.642 62.9942L125.658 36.8131L137.448 36.9996Z"
        fill="#B3B6B9"
      />
      <path
        d="M148.048 37.1679L159.896 37.3544L159.795 64.3078L147.978 63.8537L148.048 37.1679Z"
        fill="#B3B6B9"
      />
      <path
        d="M208.963 66.1992L197.018 65.741L197.216 37.9443L209.193 38.1349L208.963 66.1992Z"
        fill="#B3B6B9"
      />
      <path
        d="M234.151 67.17L222.141 66.7078L222.408 38.3435L234.452 38.5341L234.151 67.17Z"
        fill="#B3B6B9"
      />
    </svg>
  )
}
